(function(){
  const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>Array.from(r.querySelectorAll(s));
  function toast(m){const t=$('#toast');if(!t)return;t.querySelector('span').textContent=m;t.classList.add('show');clearTimeout(t._t);t._t=setTimeout(()=>t.classList.remove('show'),2600)}

  /* range filter (chips + range cards) */
  function setFilter(f){
    $$('.chip').forEach(c=>c.setAttribute('aria-pressed',String(c.dataset.f===f)));
    $$('.range').forEach(r=>r.classList.toggle('on',r.dataset.r===f));
    $$('#grid .card').forEach(c=>{c.hidden=!(f==='all'||c.dataset.range===f||c.dataset.range==='all')});
  }
  document.addEventListener('click',e=>{
    const chip=e.target.closest('.chip');if(chip){setFilter(chip.dataset.f);return}
    const range=e.target.closest('.range');if(range){const f=range.classList.contains('on')?'all':range.dataset.r;setFilter(f);const g=$('#products');if(g)g.scrollIntoView({behavior:'smooth'});return}

    /* card swatches */
    const sw=e.target.closest('.card .sw[data-id]');
    if(sw){const card=sw.closest('.card');card.querySelector('input[name="id"]').value=sw.dataset.id;
      $$('.sw',card).forEach(b=>b.setAttribute('aria-pressed',String(b===sw)));
      const n=card.querySelector('.sw-name');if(n)n.textContent=sw.dataset.name;
      const img=card.querySelector('.card-img');if(img&&sw.dataset.img){img.removeAttribute('srcset');img.src=sw.dataset.img}
      return}

    /* qty steppers */
    const st=e.target.closest('.qty [data-step]');
    if(st){const i=st.parentElement.querySelector('input');const min=+(i.min||0);i.value=Math.max(min,(+i.value||0)+ +st.dataset.step);i.dispatchEvent(new Event('change',{bubbles:true}));return}

    /* copy */
    const cp=e.target.closest('.copy[data-copy]');
    if(cp){(navigator.clipboard?navigator.clipboard.writeText(cp.dataset.copy):Promise.reject()).then(()=>toast('Copied to clipboard'),()=>toast(cp.dataset.copy))}
  });

  /* product page */
  const data=$('#pData');
  if(data){
    const V=JSON.parse(data.textContent).variants, sel={};
    $$('.pdp .sw[aria-pressed="true"]').forEach(b=>sel[b.dataset.pos]=b.dataset.value);
    const main=$('#pMain'), thumbs=$$('#pThumbs button');
    function show(src){if(main&&src){main.removeAttribute('srcset');main.src=src}thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.src===src)))}
    function filterThumbs(colour){const h=(colour||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
      const match=thumbs.filter(t=>t.dataset.colour===h);thumbs.forEach(t=>t.hidden=match.length>0&&!match.includes(t))}
    function update(){
      const v=V.find(x=>x.options.every((o,i)=>!sel[i+1]||o===sel[i+1]));if(!v)return;
      $('#pId').value=v.id;$('#pPrice').textContent=v.price;
      const btn=$('#pAdd');btn.disabled=!v.available;btn.textContent=v.available?'Add to cart':'Sold out';
      Object.keys(sel).forEach(k=>{const o=$('#pOptVal'+k);if(o)o.textContent=sel[k]});
      filterThumbs(sel[1]);
      const firstVisible=thumbs.find(t=>!t.hidden);show(v.image||(firstVisible&&firstVisible.dataset.src));
      const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u);
    }
    $$('.pdp .sw').forEach(b=>b.addEventListener('click',()=>{sel[b.dataset.pos]=b.dataset.value;
      $$(`.pdp .sw[data-pos="${b.dataset.pos}"]`).forEach(x=>x.setAttribute('aria-pressed',String(x===b)));update()}));
    thumbs.forEach(t=>t.addEventListener('click',()=>show(t.dataset.src)));
    filterThumbs(sel[1]);
  }
})();
